import { createIcon } from '../createIcon';
import { ReactComponent as IconLockAlt } from '../svg/lock-alt.svg';

export default createIcon(IconLockAlt);
